// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nnXjwewMTAETWVu3EhNs{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.nnXjwewMTAETWVu3EhNs .p_L3G2gJ_ngCGoNhlqPN{max-width:1024px;width:100%;height:100%}.nnXjwewMTAETWVu3EhNs .SG9VlBjovUWpfmeD2Y9J{margin:auto;height:100%;display:flex;justify-content:center;flex-direction:column;align-items:center}.nnXjwewMTAETWVu3EhNs .SG9VlBjovUWpfmeD2Y9J .MByWcUeGVzfb5Kb6kcXr{flex:0;text-align:bottom}.nnXjwewMTAETWVu3EhNs .SG9VlBjovUWpfmeD2Y9J p{flex:0 0}.nnXjwewMTAETWVu3EhNs .SG9VlBjovUWpfmeD2Y9J strong{font-weight:500}.nnXjwewMTAETWVu3EhNs .SG9VlBjovUWpfmeD2Y9J .cyY_AaJNyy0acSDBqG_B{color:#6e32f0;font-size:14px;text-align:center;margin-top:4em;flex:0 1 20px}.nnXjwewMTAETWVu3EhNs .Dp44ijM__g4OAqbnXrC1{width:100% !important;max-width:100% !important}.nnXjwewMTAETWVu3EhNs .MByWcUeGVzfb5Kb6kcXr{color:#6e32f0;text-align:center;font-size:15px;font-weight:600;margin-bottom:2rem;letter-spacing:.6rem;text-transform:uppercase}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"GameEngines": `nnXjwewMTAETWVu3EhNs`,
	"rightComponent": `p_L3G2gJ_ngCGoNhlqPN`,
	"carouselItem": `SG9VlBjovUWpfmeD2Y9J`,
	"title": `MByWcUeGVzfb5Kb6kcXr`,
	"thanks": `cyY_AaJNyy0acSDBqG_B`,
	"image": `Dp44ijM__g4OAqbnXrC1`
};
export default ___CSS_LOADER_EXPORT___;
